import { useMutation } from '@tanstack/react-query'

import type { LegacyDepositRequest, LegacyDepositResponse } from '../../types/deposit.js'

import { apiClient } from '../../lib/client.js'

export const useInitiateLegacyDepositMutation = () => {
  return useMutation({
    mutationFn: async (data: LegacyDepositRequest) => {
      const response = await apiClient.client.post<LegacyDepositResponse>(
        '/payment/initiate-legacy-deposit',
        data
      )
      return response.data
    },
  })
}
